import type {
  SearchAlertsJobPreferencesBannerProps,
  SearchAlertsJobPreferencesBannerXinglet,
} from '@xing-com/crate-jobs-xinglets';

import { JobPreferencesSearchAlertBanner } from './components';

export default class JobPreferencesBanner
  implements SearchAlertsJobPreferencesBannerXinglet
{
  public getComponent() {
    return ({
      itemCount,
      trackingToken,
    }: SearchAlertsJobPreferencesBannerProps): JSX.Element => (
      <JobPreferencesSearchAlertBanner
        itemCount={itemCount}
        trackingToken={trackingToken}
      />
    );
  }
}
